import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

document.addEventListener("DOMContentLoaded", function (event) {

    setTimeout(() => {
        let allAnchorLinks = document.querySelectorAll('a[href^="#"]');
        if (allAnchorLinks && allAnchorLinks.length) {

            const mainNav = document.querySelector('.header-wrapper');
            let mainNavHeight = mainNav.offsetHeight;
    
            // Handle clicking on anchor links
            if (allAnchorLinks.length > 0) {
                gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
    
                allAnchorLinks.forEach((anchorLink) => {
                    anchorLink.addEventListener('click', (e) => {
                        e.preventDefault();
                        
                        const target = document.querySelector(anchorLink.getAttribute('href'));
                        const targetId = anchorLink.getAttribute('href').substring(1);
        
                        gsap.to(window, {
                            scrollTo: { y: target, offsetY: mainNavHeight },
                            duration: 1
                        });
                        history.pushState(null, '', `#${targetId}`);
                    });
                });
            }
    
            // Programatically go to anchor if hash is found in URL
            const hash = window.location.hash;
            if (hash) {
                setTimeout(() => {
                    gsap.to(window, {
                        scrollTo: { y: hash, offsetY: mainNavHeight },
                        duration: 1
                    });
                }, 500)
            }
        }
    }, 500)
})
